import store from "@/store/index";
import router from "@/router/index";

export function RestartTotem() {
  store.commit("compra/resetCompra");
  // .catch: estando já na Home, o vue-router rejeita com NavigationDuplicated
  // e a rejeição não tratada subia como erro global.
  router.push("/cabine/home").catch(() => {});
}
